<template>
    <div class="guide-grid-row__programs" :style="{'--translate-x': setTranslateRow(props.items, props.channelIdx)}">
        <guide-program
            v-for="(program, indexProgram) of props.items" 
            :key="`${props.channelId}_${program.id}`"
            :program="program"
            :channel-idx="props.channelIdx"
            :items-length="props.items.length"
            :program-idx="indexProgram"
            :ref-grid="props.refGrid"
            @click-program="onClickProgram"
        />
    </div>
</template>

<script setup lang="ts">
    import type { PropType } from "vue";
    import type { ProgramGuideItem } from "@ca.vmedia.tv/domains";
    import { useGuideStore } from "@/stores/Guide";
    import { storeToRefs } from 'pinia';

    const GuideStoreModule = useGuideStore();
    const {
        timeMsPerPixel: timePerPixel,
        timelineBarTimes: barTimes,
    } = storeToRefs(GuideStoreModule)

    const props = defineProps({
        items: {
            type: Array as PropType<ProgramGuideItem[]>,
            required: true,
            default: () => [],
        },
        channelIdx: {
            type: Number,
            required: true,
        },
        channelId: {
            type: [Number, null] as PropType<number | null>,
            required: true,
        },
        refGrid: {
            type: [HTMLElement, null] as PropType<HTMLElement | null>,
            required: true,
        },
    });

    const emit = defineEmits(['click-program']);


    const onClickProgram = (): void => {
        emit('click-program');
    };
    const setTranslateRow = (programs: ProgramGuideItem[], _channelIdx: number): string => {
        if (programs === undefined || programs.length === 0) {
            return `0px`;
        }

        const timeLine = barTimes.value;
        let programDurationPlusGaps = 0;
        let offsetRow = 0;

        programs.forEach((program: ProgramGuideItem) => {
            const durationProgramToMs = (program && program.lengthInS ? program.lengthInS * 1000 : 0) / timePerPixel.value;
            programDurationPlusGaps += durationProgramToMs;
        });

        const firstProgram: ProgramGuideItem = programs[0];
        const endProgram: ProgramGuideItem = programs[programs.length - 1];

        if (firstProgram !== null
            && firstProgram !== undefined
            && firstProgram.recentAirTime !== null 
            && firstProgram.recentAirTime.startTime !== null
            && endProgram !== null
            && endProgram !== undefined
            && endProgram.recentAirTime !== null 
            && endProgram.recentAirTime.startTime !== null
            && endProgram.lengthInS !== null
        ) {
            const firstTimeMark: number = timeLine[0];
            const startTimeRow: number | null = firstProgram.recentAirTime.startTime;
            const endTimeRow: number | null = endProgram.recentAirTime.startTime + endProgram.lengthInS * 1000;

            
            if (startTimeRow && endTimeRow){
                const durationRowToMs = endTimeRow - startTimeRow;
                const diffTimeMarkToProgram = firstTimeMark - startTimeRow;
                const koef = diffTimeMarkToProgram / durationRowToMs;
                offsetRow = koef * programDurationPlusGaps;
            }
        }

        return `${Math.floor(offsetRow)}px`;
    }
</script>
